import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";

const groheQuotingToolResult = (props) => {

  const {subParts, lookActiveFeature} = props;
  if (!subParts) {
    return null
  }

  return (
    <div className="grohe-section__description">
      <div className="grohe-section__title">
        <FormattedMessage id="grohe.wizard.finished.title" values={{wizardName: "Vanity"}} />
      </div>
      <div className="grohe-section__description grohe-quotingTool__description">
        wizard is finished, thank you
      </div>
      {lookActiveFeature ? <LookFeatureImage/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {wizardStep} = store.groheQuotingToolState;
  return {
    lookActiveFeature,
    wizardStep,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(groheQuotingToolResult)
);
